import React from "react";
import axios from "axios";
import { Component } from "react";
import ReactModal from "react-modal";
import SglContext from "../SglContext";
import "./videos.css";
import VideoSubscription from "../videos/VideoSubscription";


// IMPORT IMAGES
import facebook_icon from "../images/facebook.png";
import facebook_icon_t from "../images/f-t.png";
import twitter_icon from "../images/twitter.png";
import twitter_icon_t from "../images/t-t.png";

import message_icon from "../images/message.png";
import message_icon_t from "../images/m-t.png";

import close_icon from "../images/close.png";
import report_icon from "../images/report.png";
import download_video from "../images/download-vid.png";
import add_playlist_icon from "../images/add-playlist.png";
import delete_image from "../images/trash.png";
import indicator_icon from "../images/Indicator.gif";
import play_video from "../images/play-video.png";
import play from '../images/play19.png';


import $ from 'jquery';

// import jwplayer from "../includes/jwplayer/jwplayer.js";
import JWPlayer from '@jwplayer/jwplayer-react';

window.jQuery = $
// window.jwplayer = jwplayer;
// window.JWPlayer = JWPlayer;
// jwplayer.key="JKaGe+jVCFPNCGQhEwn0tWhD6LqaQTY/PXPuAQ=="


var AddModal = ReactModal;
// const sgl_webservice_videos = Sgl.sglApiUrl + '/iphonev2/videosv2/';
const is_mobile = false;

/* VideoPlayer Component 
-------------------------------------------------*/
class VideoPlayer extends React.Component {

  get sgl_webservice_videos() {
    return this.context.sglApiUrl + '/iphonev2/videosv2/';
  }

  constructor(props) {
    super(props);

    // this.openSelectCardModal = this.openSelectCardModal.bind(this);
    // this.closeSelectCardModal = this.closeSelectCardModal.bind(this);

    // this.openAddCreditCardModal = this.openAddCreditCardModal.bind(this);
    // this.closeAddCreditCardModal = this.closeAddCreditCardModal.bind(this);
    // this.addCreditCard = this.addCreditCard.bind(this);

    this.closeDoSubscriptionModal = this.closeDoSubscriptionModal.bind(this);
    this.closePlayVideoModal = this.closePlayVideoModal.bind(this);

    this.afterOpenModal = this.afterOpenModal.bind(this);

    this.openGetVideoUrlModal = this.openGetVideoUrlModal.bind(this);
    this.closeGetVideoUrlModal = this.closeGetVideoUrlModal.bind(this);
    this.afterOpenUrlModal = this.afterOpenUrlModal.bind(this);

    this.openReportProblemModal = this.openReportProblemModal.bind(this);
    this.closeReportProblemModal = this.closeReportProblemModal.bind(this);

    this.openAddToPlaylistModal = this.openAddToPlaylistModal.bind(this);
    this.closeAddToPlaylistModal = this.closeAddToPlaylistModal.bind(this);
    // this.getVideoUrl = this.getVideoUrl.bind(this);
    this.fetchFile = this.fetchFile.bind(this);
    this.openDownloadSubscriptionModal = this.openDownloadSubscriptionModal.bind(this);
    this.closeDownloadSubscriptionModal = this.closeDownloadSubscriptionModal.bind(this);
    this.downloadVideoAfterSubscribe = this.downloadVideoAfterSubscribe.bind(this);

    this.state = {
      is_open_get_video_url: false,
      is_open_report_problem_modal: false,
      is_open_add_to_playlist_modal: false,

      report_problem_error_msg: '',
      video_reported: false,

      video_playlists: [],
      create_playlist_error_msg: '',
      create_playlist_success_msg: '',
      fetching_playlist: true,
      is_open_play_video_modal: false,

      is_open_download_subscription_modal: false,
      download_purchased: false
    };
  }

  componentWillMount() {

  }

  // openViewRefundPolicyModal() {
  //     this.setState({
  //       this.props.is_open_play_video_modal: true,
  //     });
  // }
  getBrowserInfo() {
    var sBrowser;
    var sUsrAg = window.navigator.userAgent;

    // The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = "unknown";
    }
    return sBrowser;
  }

  ////// download functions ///////////
  fetchFile() {
    var vid = this.props.video_to_play.videos_sgl_id;
    if (this.props.video_to_play.video_downloadable || this.state.download_purchased) {
      window.open(
        this.sgl_webservice_videos + 'Download/vid/' + vid + '/customer_id/' + this.props.company_id,
        '_blank' // <- This is what makes it open in a new window.
      );
      // window.location.href = sgl_webservice_videos + 'Download/vid/'+vid+'/customer_id/'+sgl_company_token;

      // return sgl_webservice_videos + 'Download?vid='+vid+'&customer_id='+sgl_company_token;
    } else {
      this.openDownloadSubscriptionModal();
    }
  }

  openDownloadSubscriptionModal() {
    this.setState({
      is_open_download_subscription_modal: true,
    });
    // jwplayer("myElement").play(false);
  }

  closeDownloadSubscriptionModal() {
    this.setState({
      is_open_download_subscription_modal: false,
    });
    // jwplayer("myElement").play();
  }
  downloadVideoAfterSubscribe() {
    this.closeDownloadSubscriptionModal();
    this.setState({ download_purchased: true });
    var vid = this.props.video_to_play.videos_sgl_id;
    window.open(
      this.sgl_webservice_videos + 'Download/vid/' + vid + '/customer_id/' + this.props.company_id,
      '_blank' // <- This is what makes it open in a new window.
    );
    // window.location.href = sgl_webservice_videos + 'Download/vid/'+vid+'/customer_id/'+sgl_company_token;

    // return sgl_webservice_videos + 'Download?vid='+vid+'&customer_id='+sgl_company_token;
  }

  ////// end download functions ///////////

  componentDidMount() {
    // Listen for tab close, refresh, or browser exit
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }
  
  componentWillUnmount() {
    // Clean up the listener
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }
  
  handleBeforeUnload = () => {
    this.logVideoPlayback('video closed');
  };
  
  closePlayVideoModal() {
    this.setState({ download_purchased: false });
    this.logVideoPlayback("video closed");
    this.props.closeModal()
    // this.setState({
    //   this.props.is_open_play_video_modal: false,
    // });

  }
  closeDoSubscriptionModal() {
    this.props.closeSubscriptionModal()
  }

  afterOpenModal() {
    // if (!is_mobile) {
    if (this.props.playing_preview) {
      document.getElementById('share-media').style.visibility = 'hidden';
    } else {
      this.logVideoPlayback('video played');
      var parser = document.createElement('a');
      parser.href = this.props.play_video_path;
      this.context.reportToGA('/sgl-wp-plugin/'+this.context.company_urlpath+'/videos/playback'+parser.pathname);
      this.context.reportToFB('/sgl-wp-plugin/'+this.context.company_urlpath+'/videos/playback'+parser.pathname);
    }
    //   jwplayer("myElement").setup({ 
    //     "playlist": [{
    //       "sources": [
    //         {
    //           // "default": false,
    //           // "type": "hls",
    //           "file": this.props.play_video_path,
    //           // "label": "0",
    //           // "preload": "metadata"
    //         }
    //       ]
    //     }],
    //     "autostart": true,
    //     "width": '100%',
    //     "height": '100%'
    //   });
    // }
  }
  logVideoPlayback(video_state) {
    var browser = this.getBrowserInfo();
    axios
      .get(this.sgl_webservice_videos + 'LogVideoPlayback', {
        params: {
          customer_id: this.props.company_id,
          vid: this.props.video_to_play.videos_sgl_id,
          browser_info: browser,
          ip_address: this.context.ip_address,
          isMobile: this.context.is_mobile,
          is_iphone: false,
          state: video_state,
          from_wp_api: true,
        },
      })
      .then(
        (response) => {

        },
        (error) => { }
      );
  }

  ///////// video player functions ///////////
  // getVideoUrl(video) {
  //     var video_url = '';
  //     if(video && video.videos_filepath && video.videos_filename){
  //         video_url = video.videos_other_url +
  //         "/" +
  //         video.videos_filepath.substring(
  //             video.videos_filepath.indexOf("/") + 1
  //         ) +
  //         "/" +
  //         video.videos_filename;
  //     }

  //     return video_url;
  // }
  getVideoDetailUrl(video, encode = true) {
    
    let base_path = this.context.basePath ? this.context.basePath : '';
    
    // Remove trailing slash from base_path if it exists
    if (base_path.endsWith('/')) {
      base_path = base_path.slice(0, -1);
    }
    
    let protocol = window.location.protocol;
    let hostname = window.location.hostname;
    let port = window.location.port ? ':' + window.location.port : '';
    
    var video_url = protocol + '//' + hostname + port + base_path + '/videos/detail?vid=' + video.videos_sgl_id + '&t=' + video.share_code;
    
    return encode ? encodeURIComponent(video_url) : video_url;
  }

  getVideoPlayerFaults(video) {
    var video_faults = "";
    if (video.classes_class_type == "Jumpers") {
      var faults_one =
        video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
      var faults_two =
        video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

      if (video.videos_trip_type.toString().toLowerCase() == 'jo') {
        // $faults = $trip->time_fault_two + $trip->faults_two;
        video_faults = ' - Jump Off';
        if (video.entryxclasses_time_two > 0) {
          video_faults += " with " + faults_two + " faults in " + video.entryxclasses_time_two + " secs.";
        } else if (faults_two > 0) {
          video_faults += " with {$faults} faults.";
        }
      } else {
        // $faults = $trip->time_fault_one + $trip->faults_one;
        video_faults += ' - Round 1';
        if (video.entryxclasses_time_one > 0) {
          video_faults += " with " + faults_one + " faults in " + video.entryxclasses_time_one + " secs.";
        } else if (faults_one > 0) {
          video_faults += " with " + faults_one + " faults.";
        }
      }


    } else if (video.classes_class_type == "Hunters") {
      // getting sum or avg of non-zero score values
      var score_array = [
        video.entryxclasses_scoreone,
        video.entryxclasses_scoretwo,
        video.entryxclasses_scorethree,
        video.entryxclasses_scorefour,
        video.entryxclasses_scorefive,
        video.entryxclasses_scoresix,
      ];
      var non_zero_nums = score_array.filter(
        (item) => isFinite(item) && item !== 0
      );
      var score = 0;
      if (non_zero_nums.length > 0) {
        score = non_zero_nums.reduce((a, b) => a + b, 0);
        // if(hunter_scoreby == "Average Score"){
        //     score = score/non_zero_nums.length;
        // }
      }

      if (score > 0) {
        video_faults = " with " + score + " score.";
      }
    }

    return video_faults;
  }


  ///// get URL functions ///////
  openGetVideoUrlModal() {
    this.setState({
      is_open_get_video_url: true,
    });
    // jwplayer("myElement").play(false);
  }
  afterOpenUrlModal() {
    const input = document.getElementById('video_url');
    input.focus();
    input.select();
  }
  copyToClipboard(id) {
    var copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("Copy");
    this.closeGetVideoUrlModal();
    // e.target.innerHTML = "Copied!";
    // setTimeout(function(){ e.target.innerHTML = "Copy"; }, 2000);
    return false;
  }
  closeGetVideoUrlModal() {
    this.setState({
      is_open_get_video_url: false,
    });
    // jwplayer("myElement").play();
  }
  ///// end get URL functions ///////

  ///// report problem functions ///////

  callReportProblemAPI(subject, description, video_id) {
    var browser = this.getBrowserInfo();
    axios.get(this.sgl_webservice_videos + 'ReportProblem', {
      params: {
        complaintType: 'Video Problem',
        complaintSubject: subject,
        complaintDescription: description,
        vid: video_id,
        browser: browser,
        ip_address: this.context.ip_address,
        customer_id: this.props.company_id
      }
    }).then(res => {
      document.getElementById('report_problem').style.display = "block";
      document.getElementById('report_problem-wait').style.display = "none";
      if (res.data.result) {
        this.setState({
          video_reported: true
        });
      } else {
        this.setState({
          report_problem_error_msg: res.data.validation_result.error_messages,
        });
        document.getElementById('report_problem_warning').style.display = "block";
      }
    })
  }
  openReportProblemModal() {
    this.setState({
      is_open_report_problem_modal: true,
      video_reported: false
    });
    // jwplayer("myElement").play(false);
  }
  reportProblem() {
    document.getElementById('report_problem_warning').style.display = "none";

    let kind_of_problem = document.getElementById("kind_of_problem");
    let description = document.getElementById("prob_description");
    var error = "";

    if (kind_of_problem.value == '-1') {
      error = 'Please select Kind of Problem.';
    } else if (!description.value || description.value == '') {
      error = 'Please provide Description.';
    }
    if (error == "") {
      document.getElementById('report_problem').style.display = "none";
      document.getElementById('report_problem-wait').style.display = "block";

      this.callReportProblemAPI(kind_of_problem.value, description.value, this.props.video_to_play.videos_sgl_id);
      // this.setState({video_reported: true});

    } else {
      this.setState({ report_problem_error_msg: error });
      document.getElementById('report_problem_warning').style.display = "block";
    }

  }
  closeReportProblemModal() {
    this.setState({
      is_open_report_problem_modal: false,
      video_reported: false
    });
    // jwplayer("myElement").play();
  }
  ///// end report problem functions ///////
  ///// playlist functions ///////////
  getVideoPlaylists(video_id) {
    axios.get(this.sgl_webservice_videos + 'FetchPlaylists', {
      params: {
        video_id: video_id,
        customer_id: this.props.company_id
      }
    }).then(res => {
      if (res.data.results) {
        this.setState({
          video_playlists: res.data.playlists,
          playlist: res.data.playlists,
          fetching_playlist: false
        });
      } else {
        this.setState({
          video_playlists: [],
          fetching_playlist: false
        });
      }
    })
  }
  callAddToPlaylistAPI(video_id, playlist_id) {
    axios.get(this.sgl_webservice_videos + 'AddToPlaylist', {
      params: {
        playlist_id: playlist_id,
        video_id: video_id,
        customer_id: this.props.company_id
      }
    }).then(res => {
      if (res.data.state == 'error') {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      } else if (res.data.state == 'added') {
        this.setState({ create_playlist_success_msg: "Successfully added to playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.props.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_success_msg: "Successfully removed from playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.props.video_to_play.videos_sgl_id);
      }

    })
  }
  callCreatePlaylistAPI(video_id, playlist_name) {
    axios.get(this.sgl_webservice_videos + 'CreatePlaylist', {
      params: {
        name: playlist_name,
        video_id: video_id,
        customer_id: this.props.company_id
      }
    }).then(res => {
      if (res.data.state == 'success') {
        this.setState({ create_playlist_success_msg: "Successfully added to new playlist." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.props.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      }

    })
  }
  callRemovePlaylistAPI(playlist_id) {
    axios.get(this.sgl_webservice_videos + 'RemoveFromPlaylist', {
      params: {
        playlist_id: playlist_id,
        customer_id: this.props.company_id
      }
    }).then(res => {
      if (res.data.state == 'success') {
        this.setState({ create_playlist_success_msg: "Playlist successfully removed." });
        document.getElementById('create_playlist_success').style.display = "block";
        this.getVideoPlaylists(this.props.video_to_play.videos_sgl_id);
      } else {
        this.setState({ create_playlist_error_msg: "An error occured, Please refresh your video." });
        document.getElementById('create_playlist_warning').style.display = "block";
      }

    })
  }
  checkVideoInPlaylist(playlist_id) {
    var playlist = this.state.video_playlists.find(c => (c.sgl_id == playlist_id));
    if (playlist && playlist.VideoxPlaylists.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  openAddToPlaylistModal() {
    this.getVideoPlaylists(this.props.video_to_play.videos_sgl_id);
    this.setState({
      is_open_add_to_playlist_modal: true,
    });
    // jwplayer("myElement").play(false);
  }
  addVideoToPlaylist(e, playlist_id) {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";
    this.setState({
      fetching_playlist: true,
    });
    this.callAddToPlaylistAPI(this.props.video_to_play.videos_sgl_id, playlist_id);
  }
  addToPlaylist(video_to_play) {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";

    let playlist_name = document.getElementById("playlist_name");
    if (playlist_name.value && playlist_name.value != '') {
      this.setState({
        fetching_playlist: true,
      });
      this.callCreatePlaylistAPI(video_to_play.videos_sgl_id, playlist_name.value);
    } else {
      this.setState({ create_playlist_error_msg: "Please enter Playlist name." });
      document.getElementById('create_playlist_warning').style.display = "block";
    }
  }
  removePlaylist(playlist_id) {
    document.getElementById('create_playlist_warning').style.display = "none";
    document.getElementById('create_playlist_success').style.display = "none";
    this.setState({
      fetching_playlist: true,
    });
    this.callRemovePlaylistAPI(playlist_id)
  }
  closeAddToPlaylistModal() {
    this.setState({
      is_open_add_to_playlist_modal: false,
      fetching_playlist: true,
      video_playlists: []
    });
    // jwplayer("myElement").play();
  }
  ///// end playlist functions ///////

  ///// share functions ///////
  shareOnFB(link) {
    if (link != '') {
      var win = window.open("https://www.facebook.com/sharer/sharer.php?u=" + link, '_blank');
      win.focus();
    }
  }

  shareOnTwitter(link) {
    if (link != '') {
      var win = window.open("https://twitter.com/intent/tweet?url=" + link, '_blank');
      win.focus();
    }
  }

  mailto(link) {    
    if (link != '') {
      var encodedLink = encodeURIComponent(link);
      var win = window.open("mailto:?subject= &body=" + encodedLink, '_blank');
      win.focus();
    }
  }
  ///// end share functions ///////


  render() {
    let inIframe = false;
    if (window.location !== window.parent.location) {
      inIframe = true;
    }
    const configDefaults = { width: '100%', height: '100%' };

    return (
      <div>

        <div id=''>
          <div className="videos-player-css">
            <AddModal
              isOpen={this.props.is_open_play_video_modal}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closePlayVideoModal}
              className={"modal-width-small videos-css video-modal" + (inIframe ? ' in-iframe' : '')}
              overlayClassName="myoverlay"
              ariaHideApp={false}
            // style={customStyles}
            // contentLabel="Example Modal"
            >

              <div className='player_options'>
                <div className='thePlayer_infobox'>
                  {/* {(!this.state.playing_preview) &&  */}
                  <div className="set-inline" id="share-media">
                    <span className="social-media-icons" onClick={() => this.shareOnFB(this.getVideoDetailUrl(this.props.video_to_play))}><img className="myimg" src={facebook_icon} alt="facebook-icon" /></span>
                    <span className="social-media-icons" onClick={() => this.shareOnTwitter(this.getVideoDetailUrl(this.props.video_to_play))}><img className="myimg" src={twitter_icon} alt="twitter-icon" /></span>
                    <span className="social-media-icons" onClick={() => this.mailto(this.getVideoDetailUrl(this.props.video_to_play, false))}><img className="myimg" src={message_icon} alt="email-icon" /></span>
                  </div>
                  {/* } */}
                  <div className="top-div">
                    {(this.props.company_id == 15) ?
                      <b>PALM BEACH INTERNATIONAL EQUESTRIAN CENTER</b>
                      :
                      <b>ShowGroundsLive.com</b>
                    }
                    <br />
                    <span>#{this.props.video_to_play.entries_number} - {this.props.video_to_play.entries_horse} | {this.props.video_to_play.entryxclasses_rider_name} | {this.props.video_to_play.classes_name} {this.getVideoPlayerFaults(this.props.video_to_play)}</span>
                  </div>
                  <div className='cross-button'><img className="cross-btn-img" src={close_icon} onClick={this.closePlayVideoModal} /></div>

                </div>
                {(!this.context.is_mobile && !this.props.playing_preview && this.props.is_admin) && <div className="clipBoardButton" onClick={this.openGetVideoUrlModal}>Get Video URL</div>}

                <div className="flex-container-row">
                  <div className="flex-container-column">
                    <div className="modalVideoOptionButton" onClick={this.openReportProblemModal}><img src={report_icon} alt="Report Icon" /></div>
                    {(!this.props.playing_preview) &&
                      <div className="modalVideoOptionButton" onClick={this.openAddToPlaylistModal}><img src={add_playlist_icon} alt="Add to Playlist Icon" /></div>
                    }
                    {/* {!is_mobile && <div className="modalVideoOptionButton display_it"><img  onClick={this.fetchFile} src={download_video} alt="Download Video Icon" /></div>} */}
                    {(!this.props.playing_preview) && <div className="modalVideoOptionButton display_it"><a onClick={this.fetchFile}><img src={download_video} alt="Download Video Icon" /></a></div>}
                    {/* {(!is_mobile && !this.props.playing_preview) && <div className="modalVideoOptionButton display_it"><a href={this.fetchFile()} target="_blank"  rel="noopener noreferrer" download={this.props.video_to_play.videos_filename}><img src={download_video} alt="Download Video Icon" /></a></div>} */}
                    {/* <div className="modalVideoOptionButton"><a href={this.props.video_to_play.video_url} target="_blank"  rel="noopener noreferrer" download={this.props.video_to_play.videos_filename}><img src={download_video} alt="Download Video Icon"/></a></div> */}

                  </div>

                </div>
              </div>

              <div id="myElement" className="video-player-element">
                <JWPlayer
                  config={configDefaults}
                  file={this.props.play_video_path}
                  // playlist={this.props.play_video_path}

                  // library={process.env.PUBLIC_URL + '/jwplayer8.js?v=20230124-1'}
                  library={"https://cdn.jwplayer.com/libraries/hMVctbog.js"}
                // library='https://cdn.jwplayer.com/libraries/lqsWlr4Z.js'
                // library='../includes/jwplayer-7/jwplayer.js'
                // playlist='https://cdn.jwplayer.com/v2/playlists/playlist_media_id'
                // file= {this.props.play_video_path}
                onPlay={() => this.logVideoPlayback('video resumed') }
                onPause={() => this.logVideoPlayback('video paused') }
                onComplete={() => this.logVideoPlayback('video completed') }
                onError={ (error) => {
                  var webservice_url = this.context.sglApiUrl + "/iphone.php/webservice/LogWPPluginError";
                  axios.post(webservice_url,{
                      datetimestamp: Date.now(),
                      customer_id: this.props.company_id,
                      from_wp_api: true,
                      lineno: '',
                      colno: '',
                      message: JSON.stringify({code: error.code, message: error.message, type: error.type}),
                      user_info: `${localStorage?.getItem('user_display_name')} - ${localStorage?.getItem('user_email')}`,
                      filename: this.props.play_video_path,
                      url: window.location.href,
                  })
                }}
                />
              </div>
              <div className="bottm-div display_none display_now">
                <div className="align-center">
                  <span>#{this.props.video_to_play.entries_number} - {this.props.video_to_play.entries_horse}</span>
                  <br />
                  <span>{this.props.video_to_play.entryxclasses_rider_name}</span>
                  <br />
                  <span>{this.props.video_to_play.classes_name}</span>

                </div>
                {(!this.props.playing_preview) &&
                  <div className="btn-class">
                    <button className="mbtn" onClick={() => this.shareOnFB(this.getVideoDetailUrl(this.props.video_to_play))}><span className="social-media-icons"><img className="myimg" src={facebook_icon_t} alt="facebook-icon" /></span>SHARE</button>
                    <button className="mbtn1" onClick={() => this.shareOnTwitter(this.getVideoDetailUrl(this.props.video_to_play))}><span className="social-media-icons"><img className="myimg" src={twitter_icon_t} alt="facebook-icon" /></span>TWEET</button>
                    <button className="mbtn2" onClick={() => this.mailto(this.getVideoDetailUrl(this.props.video_to_play, false))}><span className="social-media-icons"><img className="myimg" src={message_icon_t} alt="facebook-icon" /></span> EMAIL</button>
                  </div>
                }
              </div>
            </AddModal>
            <AddModal
              isOpen={this.state.is_open_get_video_url}
              onAfterOpen={this.afterOpenUrlModal}
              onRequestClose={this.closeGetVideoUrlModal}
              className="mymodal modal-width-small"
              overlayClassName="myoverlay"
              ariaHideApp={false}
            >

              <h2>Get Video Url</h2>
              <p>Copy to clipboard: Ctrl+C, Enter</p>
              <form>
                <input type="text" id="video_url" value={this.props.video_to_play.video_url} />
                <div className="align-buttons">
                  <button className='left' onClick={this.closeGetVideoUrlModal}>
                    Close
                  </button>
                  <button id='copy' className='right' onClick={() => this.copyToClipboard('video_url')}>
                    Copy
                  </button>
                </div>
              </form>
            </AddModal>
            <AddModal
              isOpen={this.state.is_open_report_problem_modal}
              // onAfterOpen={this.afterOpenUrlModal}
              onRequestClose={this.closeReportProblemModal}
              className="mymodal modal-width-small"
              overlayClassName="myoverlay"
              ariaHideApp={false}
            >

              <h2>Report a Problem</h2>
              {this.state.video_reported ?
                <span id="problem_reported_success" className=''>Thank You!<br />Your request about the problem you are facing has been recieved. We shall contact you soon.</span>
                :
                <div>
                  <div className="add_modal_div" id='kind_div'>
                    <h4>Kind of problem</h4>
                    <div style={{ clear: "both" }}></div>
                    <div className="add_modal_div txt-field-container-modal">
                      <select className="" id='kind_of_problem'>
                        <option value="-1">Please Select...</option>
                        <option value='Incorrect horse/rider/class identification'>Incorrect horse/rider/class identification</option>
                        <option value="Poor Quality">Poor Quality</option>
                        <option value="Other">Other</option>

                      </select>
                    </div>

                  </div>
                  <div className="add_modal_div" id='desc_div'>
                    <h4>Description</h4>
                    <div style={{ clear: "both" }}></div>
                    <div className="add_modal_div txt-field-container-modal">
                      <textarea placeholder='' id="prob_description" rows="10" />
                    </div>

                  </div>
                </div>
              }
              <div id='report_problem_warning' style={{ textIndent: "2px" }} className='required display_none'>{this.state.report_problem_error_msg}</div>

              {!this.state.video_reported ?
                <div className="align-buttons">
                  <button className='left' onClick={this.closeReportProblemModal}>
                    Close
                  </button>
                  <span id="report_problem-wait" className='right display_none'>  <img src={indicator_icon} /></span>
                  <button id='report_problem' className='right' onClick={() => this.reportProblem()}>
                    Submit
                  </button>
                </div>
                :
                <div className="">
                  <button className='close-right' onClick={this.closeReportProblemModal}>
                    Close
                  </button>
                </div>
              }
            </AddModal>
            <AddModal
              isOpen={this.state.is_open_add_to_playlist_modal}
              // onAfterOpen={this.afterOpenUrlModal}
              onRequestClose={this.closeAddToPlaylistModal}
              className="mymodal modal-width-small"
              overlayClassName="myoverlay"
              ariaHideApp={false}
            >

              <h2>Add to Playlist</h2>
              {this.state.fetching_playlist ?
                <span id="fetch-playlist-wait">  <img src={indicator_icon} /></span>
                :
                <div className="add_modal_div" id='add_people_name_div'>

                  {(this.state.video_playlists.length > 0) ?
                    this.state.video_playlists.map((play_list, index) => {
                      return (
                        <li className='class_list_li'>
                          <input className="checkbox-class" type="checkbox" name="playlist" id={"play_list_" + play_list.sgl_id} checked={this.checkVideoInPlaylist(play_list.sgl_id)} onChange={e => this.addVideoToPlaylist(e, play_list.sgl_id)} />
                          <label for={"play_list_" + play_list.sgl_id}>  {play_list.name}</label>
                          <img src={delete_image} className="placing-icon trash-icon" onClick={() => this.removePlaylist(play_list.sgl_id)} />

                        </li>

                      )
                    })
                    :
                    <span>You haven't created any playlist yet.</span>
                  }

                </div>
              }
              <br />
              <br />
              <h2>Create Playlist</h2>

              <input type="text" placeholder='Playlist name' id="playlist_name" />
              <div id='create_playlist_warning' style={{ textIndent: "2px" }} className='required display_none'>{this.state.create_playlist_error_msg}</div>
              <div id='create_playlist_success' style={{ textIndent: "2px" }} className='success_msg display_none'>{this.state.create_playlist_success_msg}</div>
              <div className="align-buttons">
                <button className='left' onClick={this.closeAddToPlaylistModal}>
                  Close
                </button>
                <button id='copy' className='right' onClick={() => this.addToPlaylist(this.props.video_to_play)}>
                  Add
                </button>
              </div>
            </AddModal>
            <AddModal
              isOpen={this.props.is_open_do_subscription_modal}
              // onAfterOpen={this.afterOpenUrlModal}
              onRequestClose={this.closeDoSubscriptionModal}
              className={"mymodal subscription-modal" + (inIframe ? ' subscription-in-iframe' : '')}
              overlayClassName="myoverlay"
              ariaHideApp={false}
            >
              <VideoSubscription
                is_download_subscription={this.props.is_download_subscription}
                is_video_subscription={true}
                subscription_type={'video'}
                video_to_play={this.props.video_to_play}
                closeSubscriptionModal={this.closeDoSubscriptionModal}
                playVideoAfterSubscribe={this.props.playVideoAfterSubscribe}
                company_id={this.props.company_id}
                ip_address={this.context.ip_address}
                ref={this.props.VideoSubscriptionElement}
              />
            </AddModal>
            {(this.state.is_open_download_subscription_modal) &&
              <AddModal
                isOpen={this.state.is_open_download_subscription_modal}
                // onAfterOpen={this.afterOpenUrlModal}
                onRequestClose={this.closeDownloadSubscriptionModal}
                className={"mymodal subscription-modal" + (inIframe ? ' subscription-in-iframe' : '')}
                overlayClassName="myoverlay"
                ariaHideApp={false}
              >
                <VideoSubscription
                  is_download_subscription={true}
                  is_video_subscription={true}
                  subscription_type={'video'}
                  video_to_play={this.props.video_to_play}
                  closeSubscriptionModal={this.closeDownloadSubscriptionModal}
                  playVideoAfterSubscribe={this.downloadVideoAfterSubscribe}
                  company_id={this.props.company_id}
                  ip_address={this.context.ip_address}
                  ref={this.props.VideoSubscriptionElement}
                />
              </AddModal>
            }

                </div>
            </div>
            
          </div>
      
        );
    }
}

VideoPlayer.contextType = SglContext;
export default VideoPlayer;